export const amountToDollars = (amount) => {
  return (amount / 100) || 0.00;
};

export const isNullish = (value) => {
  return value === null || value === undefined || value === '' || value === 0;
}